import ContactHero from "./components/ContactHero";
import ContactInfo from "./components/ContactInfo";
import InquiryForm from "./components/InquiryForm";

export default function Contact() {
  return (
    <>
      <ContactHero />
      <ContactInfo />
      <InquiryForm />
    </>
  );
}